module.exports = __webpack_public_path__ + "static/img/09.f8730a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/junActivitySpecialty2/09.png
// module id = 3q4+
// module chunks = 0